<template>
  <div v-if="session && Object.keys(session).length > 0" class="bg-white drop-shadow-md rounded-lg mb-4">
    <div class="relative">
      <a
          :href="session.url"><img
          :alt="session.yogaType.title"
          src="https://liveyogateachers.com/media/placeholder/_640x364_crop_center-center_95_none/Screenshot-2023-05-22-at-16.15.13.png"
          class="rounded-t-lg w-full">
      </a>
      <div class="absolute top-4 right-4 flex flex-col justify-end">
        <span v-for="tag in session.tags" :key="tag"
              class="g--tag bg-white mb-1"><span class="mr-2 inline-block">{{ tag.emoji }} {{ tag.title }}</span></span>
      </div>
    </div>
    <div class="px-5 pt-8 pb-5 relative">
      <h3 class="text-xl font-medium text-black"><a
          :href="session.url"
          class=" flex items-center flex-wrap justify-between hover:text-teal"><span class="pr-2">{{
          session.yogaType.title
        }}</span> <span
          class="tracking-wider text-sm uppercase font-normal">Online - {{ session.minutes }} min</span></a></h3>
      <div class=" leading-5 text-bluegray mt-2.5 flex justify-between items-center"><a
          :href="session.teacherSlug">
        With <span class="font-medium  hover:text-teal">{{ session.teacher.fullName }}</span></a>
        <div class="font-bold flex text-teal">
          <span v-if="session.amountPaidFriendly != session.priceInBookingCurrency">
            <span class="line-through">{{ session.priceInBookingCurrency }}</span>
            <span class="ml-2">{{ session.amountPaidFriendly }}</span>
          </span>
          <span v-else>{{ session.priceFriendly }}</span>
        </div>
      </div>
      <div class="flex-shrink-0 flex items-start justify-between flex-wrap mt-2 pr-2">
        <div class="text-bluegray">
          <span class="block">{{ session.startDay }}</span>
          <span class="block">{{ session.startTime }} — {{ session.endTime }} ({{ session.timezoneFriendly}})</span>
        </div>
      </div>
      <div class="mt-5 inline-block">
        <!--        <div><span class="g&#45;&#45;button mt-5">Book this class</span></div>-->
        <checkout v-if="!session.userIsRegistered && showCheckout" :session="session"></checkout>
        <div v-else-if="session.userIsRegistered">
          <div class="text-green-darker inline-block font-medium">You are booked!</div>
          <div class="mt-1 text-sm" v-if="session.voucher">
            Voucher: <span class="font-bold">{{ session.voucher  }}</span>
          </div>
        </div>
      </div>
      <div
          class="absolute bottom-4 md:bottom-5 right-4 md:right-5 rounded-full w-12 h-12 md:w-16 md:h-16 overflow-hidden">
        <img v-if="session.teacherPhotoUrl" :src="session.teacherPhotoUrl"
             :alt="session.teacher.fullName" class="absolute top-0 left-0 object-cover w-full h-full"></div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from 'vue';
import Checkout from './Checkout.vue';

const session = ref({});

let props = defineProps({
  sessionProp: Object,
  sessionId: {
    type: Number,
    default: 0
  }
});

onMounted(() => {
  if (props.sessionId != 0) {
    fetchSession();
  } else {
    session.value = props.sessionProp
  }
});

const showCheckout = true;

const fetchSession = () => {
  console.log('Fetching session with id ' + props.sessionId);
  fetch('/api/sessions/all?sessionId=' + props.sessionId)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        session.value = response.sessions[0];
      });
}
</script>